import { EMPTY_LIST } from '../../../constants/common'
import { PdfViewer } from '../../PdfViewer'
import { EmailGoogleTemplateExternalVariablesList } from '../EmailGoogleTemplateExternalVariablesList'

import * as styles from './EmailGoogleTemplateWrapper.module.css'

function EmailGoogleTemplateWrapper({
  activeVariable,
  template,
  variables,
  onChangeVariables,
  onHighlightVariable,
}) {
  return (
    <div className={styles.template}>
      <div className={styles.preview}>
        <PdfViewer
          className={styles.pdfViewer}
          defaultOpenPanels={EMPTY_LIST}
          file={{ origin: template.pdf_export_link }}
          search={activeVariable}
        />
      </div>
      <div className={styles.variablesSection}>
        <EmailGoogleTemplateExternalVariablesList
          templateName={template.name}
          variables={variables}
          onChangeVariables={onChangeVariables}
          onHighlightVariable={onHighlightVariable}
        />
      </div>
    </div>
  )
}

export default EmailGoogleTemplateWrapper
